import React, { useState } from "react";
import { mapTableRows } from "../../../../../utils";
import { Button, DevNote, TableAdv } from "../../../../../components";
import AddVmsModal from "../../Modals/VmsModals/AddVmsModal";

const VmsConfigure = ({ category, type, selectedModule }) => {
  const [showAddModal, setShowAddModal] = useState(false);
  const columns = [
    {
      key: "sNo",
      label: "S.No",
      columnMenu: false,
    },
    {
      key: "vmsType",
      label: "VMS Type",
      columnMenu: false,
    },
    {
      key: "customerName",
      label: "Customer Name",
      columnMenu: false,
    },
    {
      key: "url",
      label: "URL",
      columnMenu: false,
      render: (row) => <div className="text-info-500">{row.url}</div>,
    },
    {
      key: "userName",
      label: "User Name",
      columnMenu: false,
    },
    {
      key: "created",
      label: "Created",
      columnMenu: false,
    },
    {
      key: "lastUpdated",
      label: "Last Updated",
      columnMenu: false,
    },
  ];
  const rows = Array.from({ length: 10 }, (_, i) => ({
    sNo: i + 1,
    vmsType: "FieldGlass",
    customerName: "Tektree",
    url: "www.fieldglass.eu",
    userName: "Astha",
    created: "10-9-2025",
    lastUpdated: "11-10-2025",
  }));
  const mappedRows = mapTableRows(rows, columns);

  if (selectedModule === "bs") {
    return (
      <div className="mt-3">
        <p>
          This feature is not available for Bench Sales. However, you can
          configure the following features:
        </p>
        <div className="ms-3">
          <h6 className="text-dark my-2 -ms-1">
            Available Features for Bench Sales:
          </h6>
          <p>
            1. <strong>Kult AI (Text)</strong> — Marketplace &gt; AI (Beta) &gt;
            Kult AI (Text) &gt; Setup / Configure
          </p>
          <p>
            2. <strong>Apollo</strong> — Marketplace &gt; Productivity &gt;
            Apollo &gt; Setup / Configure
          </p>
          <p>
            3. <strong>G-Suite</strong> — Marketplace &gt; Bulk Email &gt;
            G-Suite &gt; Setup / Configure
          </p>
          <p>
            4. <strong>Outlook</strong> — Marketplace &gt; Bulk Email &gt;
            Outlook &gt; Setup / Configure
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-4 shadow-sm p-2 bg-white border border-gray-100 rounded">
      <DevNote>
        <div>
          Table data is currently dummy, so a loader is not implemented. Add
          Loader when real data is available.
        </div>
      </DevNote>
      <TableAdv
        rows={mappedRows}
        columns={columns}
        toolbarRight={{
          search: true,
          add: [
            {
              component: (
                <Button
                  title={"Add VMS"}
                  size="sm"
                  onClick={() => setShowAddModal(true)}
                />
              ),
            },
          ],
        }}
      />
      <AddVmsModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
      />
    </div>
  );
};

export default VmsConfigure;
